import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NbAuthService, NbResetPasswordComponent, NB_AUTH_OPTIONS } from '@nebular/auth';
import { AuthService } from '../../../_services/auth.service';
import { LoggerService } from '../../../_services/logger.service';
import { ToastrService } from '../../../_services/toastr.service';
import { NotificationService } from '../../../_services/notification.service';
import { Documents_Select_Column_Documents_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns } from '../../../../generated/graphql';

@Component({
    selector: 'change-psw',
    templateUrl: './change-psw.component.html',
    styleUrls: ['./change-psw.component.scss'],
    standalone: false
})
export class ChangePswComponent extends NbResetPasswordComponent {

  override user: any;

  constructor(
    // Servizi richiesti da NbResetPasswordComponent
    protected authService: NbAuthService,
    @Inject(NB_AUTH_OPTIONS) protected override options = {},
    protected override cd: ChangeDetectorRef,
    protected override router: Router,
    // Servizi custom
    private auth: AuthService,
    private loggerService: LoggerService,
    private toastrService: ToastrService,
    private notificationService: NotificationService,
  ) {
    super(
      authService,
      options,
      cd,
      router,
    );
  }

  // Reset pass == change pass, Nebular usa dei nomi del cazzo
  override resetPass() {

    this.errors = this.messages = [];
    this.submitted = true;

    this.auth.changePassword(this.user.oldPassword, this.user.newPassword).toPromise()
    .then(res => {
        if (res?.errors && res.errors.length > 0)
          throw new Error("Errore durante la modifica della password");
        this.submitted = false;
        this.toastrService.success("Password Modificata", "Verrai ora riportato allo schermo di login");
        // Redirect alla pagina di login
        setTimeout(() => {
          return this.router.navigateByUrl("/auth/logout");
        }, this.redirectDelay);
    })
    .catch(err => {
      this.submitted = false;
      this.toastrService.error("Errore", "E' avvenuto un errore durante il processo di modifica password");
      this.loggerService.error(err.message);
    });
  }
}

